// Helpers for the employee headcount summary that Management Control and Employment
// Equity scorecards return: rows of { level, total, african_male, … }.

export const DEMOGRAPHICS = ['african_male', 'african_female', 'coloured_male', 'coloured_female', 'indian_male', 'indian_female'];
export const DEMOGRAPHIC_LABELS = ['African M', 'African F', 'Coloured M', 'Coloured F', 'Indian M', 'Indian F'];

const LEVEL_LABELS = {
  other_executive: 'Other executive management',
  senior: 'Senior management',
  middle: 'Middle management',
  junior: 'Junior management',
  semi_skilled: 'Semi-skilled',
  'semi-skilled': 'Semi-skilled',
  unskilled: 'Unskilled',
  disabled: 'Employees with disabilities',
};

export const levelLabel = (level = '') =>
  LEVEL_LABELS[level] || level.replace(/[_-]+/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

const sumDemographics = (row) => DEMOGRAPHICS.reduce((s, d) => s + (row[d] || 0), 0);

// The disabled row counts people already included in the occupational levels, so it is
// kept out of the totals and shown separately. Some sheets give it no total cell.
export const summariseHeadcount = (rows = []) => {
  const levels = rows.filter((r) => r.level !== 'disabled');
  const disabledRow = rows.find((r) => r.level === 'disabled');
  const sum = (key) => levels.reduce((s, r) => s + (r[key] || 0), 0);
  return {
    levels,
    totals: { total: sum('total'), ...Object.fromEntries(DEMOGRAPHICS.map((d) => [d, sum(d)])) },
    disabled: disabledRow ? { ...disabledRow, total: disabledRow.total ?? sumDemographics(disabledRow) } : null,
  };
};
